import { Shield, Sparkles, Stethoscope, Waypoints } from "lucide-react";

const sections = [
  {
    title: "Purpose",
    icon: Sparkles,
    text: "The museum gives common fears a room, a label, and a visual atmosphere. It is designed to make fear easier to observe with distance and less shame."
  },
  {
    title: "Privacy",
    icon: Shield,
    text: "The site does not send your reflections anywhere. No account. No database. No tracking system required. Slider values stay in the current browser state."
  },
  {
    title: "Not medical advice",
    icon: Stethoscope,
    text: "This experience does not diagnose, treat, or measure mental health. If fear feels overwhelming in real life, personal support or qualified professional care may matter."
  },
  {
    title: "How it works",
    icon: Waypoints,
    text: "Each exhibit combines a human description, a simple psychological explanation, common signs, a private slider, and reflection prompts. Nothing needs to be submitted."
  }
];

function About() {
  return (
    <section className="mx-auto w-full max-w-7xl px-5 py-16 lg:px-8">
      <div className="max-w-4xl">
        <p className="text-xs uppercase tracking-[0.32em] text-museum-gold">About the museum</p>
        <h1 className="mt-5 font-display text-5xl leading-tight text-balance text-museum-bone sm:text-6xl">
          A digital exhibition about the emotional architecture of fear.
        </h1>
        <p className="mt-7 text-lg leading-9 text-museum-muted">
          Museum of Human Fears is a digital exhibition about the emotional architecture of fear. It does not diagnose, treat, or measure mental health. It turns common fears into rooms, labels, questions, and atmospheres so they can be observed with more distance and less shame.
        </p>
      </div>
      <div className="mt-12 grid gap-5 md:grid-cols-2">
        {sections.map((section) => {
          const Icon = section.icon;
          return (
            <article key={section.title} className="glass-panel rounded-lg p-7">
              <div className="mb-6 flex h-12 w-12 items-center justify-center rounded-full border border-museum-gold/25 text-museum-gold">
                <Icon size={22} aria-hidden="true" />
              </div>
              <h2 className="font-display text-3xl text-museum-bone">{section.title}</h2>
              <p className="mt-4 leading-8 text-museum-muted">{section.text}</p>
            </article>
          );
        })}
      </div>
    </section>
  );
}

export default About;
